import React, { useRef } from 'react';

const TemplateHTMLPreview = ({
  htmlContent,
  style,
  disableLinks,
}) => {
  const iframeRef = useRef(null);

  const updateLinks = () => {
    const iframe = iframeRef.current;

    if (iframe && iframe.contentDocument) {
      const iframeLinks = iframe.contentDocument.querySelectorAll("a");

      iframeLinks.forEach(link => {
        if (disableLinks) {
          link.setAttribute("disabled", true);
          link.setAttribute("aria-disabled", true);
          link.style.pointerEvents = "none";
          link.addEventListener("click", (event) => event.preventDefault());
        } else {
          link.setAttribute("target", "_blank");
        }
      });
    }
  };

  const sanitizeTemplateHtml = (html) => {
    if (!html) return html;

    // NOTE: This will blank out any src attributes for images that contain liquid tags.
    // This is to prevent hitting our server when rendering the preview attempting to
    // load images that do not exist.
    const sanitizedHtml = html.replace(
      /(src)=["']([^"']*(\{\{[^}]+\}\})[^"']*)["']/g,
      (match, attribute, url) => {
        if (attribute === 'src' && url.includes('{{')) {
          return 'src=""';
        }

        return match;
      }
    );

    return sanitizedHtml;
  };

  return (
    <iframe
      ref={iframeRef}
      srcDoc={sanitizeTemplateHtml(htmlContent)}
      style={style}
      onLoad={updateLinks}
    />
  );
};

export default TemplateHTMLPreview;
